import { isEmpty } from 'lodash';
import type { RecordFormItem, RecordFormItemTab, RecordSection, TabWithSections } from '../types';
import type { TabId } from '../components/mui/common/Tabs.tsx';

export const displayOnlyFirstTab = (formItemTabs: unknown[], name: string | null | undefined) => {
  return formItemTabs.length === 1 && isEmpty(name);
};

export const getTabsWithFormError = (tabs: TabWithSections[], errorFieldIds: string[]) => {
  const hasError = (formItem: RecordFormItem) => errorFieldIds.includes(formItem.formItem.id);

  const filterFormItemTab = (formItemTab: RecordFormItemTab) => ({
    ...formItemTab,
    formItems: formItemTab.formItems.filter(hasError),
  });

  const filterSection = (section: RecordSection) => ({
    ...section,
    formItemTabs: section.formItemTabs.map(filterFormItemTab).filter((tab) => tab.formItems.length > 0),
  });

  return tabs
    .map((tab) => ({
      ...tab,
      sections: tab.sections.map(filterSection).filter((section) => section.formItemTabs.length > 0),
    }))
    .filter((tab) => tab.sections.length > 0);
};

export const getActualTabWithError = (tabsWithErrors: TabWithSections[], currentTabId: TabId) => {
  const tabWithError = tabsWithErrors.find((tab) => tab.tabNumber === currentTabId);
  return tabWithError ?? tabsWithErrors[0];
};

export const getSectionsWithErrors = (tabsWithErrors: TabWithSections[]) => {
  const sectionsWithErrors: string[] = [];

  tabsWithErrors.forEach((tab) => {
    tab.sections.forEach((section) => {
      sectionsWithErrors.push(section.id);
    });
  });

  return sectionsWithErrors;
};

export const getActualSubTabWithError = (tabsWithErrors: TabWithSections[], parentTabId: TabId, sectionId: string, subTabId: TabId) => {
  const formItemTabs = tabsWithErrors
    .find((tab) => tab.tabNumber === parentTabId)
    ?.sections.find((section) => section.id === sectionId)?.formItemTabs;

  const formItemTabWithError = formItemTabs?.find((tab) => tab.tabNumber === subTabId);
  return formItemTabWithError ?? formItemTabs?.[0];
};
